import SocialButtons from './SocialButtons';

export default SocialButtons;
